import Vue from 'vue';

import http from '@core/api/http';

Vue.prototype.$http = http;
